module.exports = __webpack_public_path__ + "assets/img/downLoad@2x.bb283f93.png";